module.exports = "<small class=\"message\" text-wrap *ngIf=\"!form.valid && (form.dirty || submitAttempt)\">{{ message }}</small>"